// extracted by mini-css-extract-plugin
export default {"text":"consent-banner_text_pKKH7","banner":"consent-banner_banner_F7BrG","link":"consent-banner_link_KXHDa","aboveSmartBanner":"consent-banner_aboveSmartBanner_fHVX2"};